// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fba672e3","453":"1fce5327","667":"9a6b241e"}[chunkId] + ".chunk.js";
};